'use client';

function within(_a) {
    var min = _a.min, value = _a.value, max = _a.max;
    return Math.max(min, Math.min(value, max));
}

export { within as default };
//# sourceMappingURL=within.js.map
